export default __webpack_public_path__ + "static/akitabox_b.4bde616631b4e903173610142cee76e8.svg";